module.exports = __webpack_public_path__ + "img/ss_blue-05.ed9e4510.jpg";